import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/apiClient";
import { SeverityBadge } from "@/components/SeverityBadge";
import { LongitudinalDashboard } from "@/components/LongitudinalDashboard";
import { ClipboardList, ChevronRight } from "lucide-react";

export default function VoiceLab() {
  const [list, setList] = useState([]);
  const [summary, setSummary] = useState({ latest: [], overall_band: null });

  useEffect(() => {
    api.get("/questionnaires").then((r) => setList(r.data));
    api.get("/voicelab/summary").then((r) => setSummary(r.data));
  }, []);

  return (
    <div className="space-y-8" data-testid="voicelab-page">
      <div>
        <span className="uppercase-label">Voice Lab</span>
        <h1 className="font-display text-3xl mt-2">Standardized questionnaires</h1>
        <p className="text-[color:var(--mano-ink-soft)] mt-2 max-w-2xl">
          Complete any questionnaire to complement your voice assessment. Each one shows an
          individual band and contributes to a combined summary.
        </p>
      </div>

      {summary.overall_band && (
        <div className="rounded-2xl border border-[color:var(--mano-border)] bg-white p-6" data-testid="voicelab-summary">
          <div className="flex items-center justify-between">
            <div>
              <div className="uppercase-label">Combined Voice Lab summary</div>
              <div className="font-display text-xl mt-1">Highest band across latest attempts</div>
            </div>
            <SeverityBadge band={summary.overall_band} size="lg" />
          </div>
          <div className="mt-4 grid sm:grid-cols-2 gap-3">
            {summary.latest.map((r) => (
              <div key={r.id} className="rounded-xl border border-[color:var(--mano-border)] p-3 flex items-center justify-between">
                <div>
                  <div className="text-sm font-semibold">{r.questionnaire_name}</div>
                  <div className="text-xs text-[color:var(--mano-ink-soft)]">Score {r.total_score}</div>
                </div>
                <SeverityBadge band={r.band} />
              </div>
            ))}
          </div>
        </div>
      )}

      <LongitudinalDashboard />

      <div className="grid sm:grid-cols-2 gap-4">
        {list.map((q) => (
          <Link
            key={q.id}
            to={`/voicelab/${q.id}`}
            data-testid={`voicelab-open-${q.id}`}
            className="rounded-2xl border border-[color:var(--mano-border)] bg-white p-6 hover:border-[color:var(--mano-primary)] transition-colors flex items-center justify-between"
          >
            <div>
              <div className="h-10 w-10 rounded-xl bg-[color:var(--mano-primary)]/10 text-[color:var(--mano-primary)] flex items-center justify-center">
                <ClipboardList size={18} />
              </div>
              <div className="font-display text-lg mt-3">{q.name}</div>
              <div className="text-sm text-[color:var(--mano-ink-soft)] mt-1 capitalize">
                {q.category.replace("_", " ")} · {q.item_count} items
              </div>
            </div>
            <ChevronRight size={18} className="text-[color:var(--mano-ink-soft)]" />
          </Link>
        ))}
      </div>
    </div>
  );
}
